import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Mission from "../components/Mission";
import Impact from "../components/Impact";
import CampaignsSection from "../components/CampaignsSection";
import Donation from "../components/Donation";
import Transparency from "../components/Transparency";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { useLanguage } from "../contexts/LanguageContext";

const Home = () => {
  const { t, lang } = useLanguage();
  return (
    <main data-testid="home-page">
      <Seo
        title={t.seo.home.title}
        description={t.seo.home.description}
        path="/"
        lang={lang}
      />
      <Navbar />
      <Hero />
      <Mission />
      <Impact />
      <CampaignsSection />
      <Donation />
      <Transparency />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
